// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  authConfig: {
    domain: 'tillster-tce-dev.auth0.com',
    client_id: 'SftI10hqBKZgT93EjjF7510EZWMDpjH8',
    redirect_uri: `${window.location.origin}/brand`,
    audience: 'https://dev.tce.tillster.com/tce-experience-admin',
  },
  baseApi: 'https://dev.tce.tillster.com',
  bossApi: 'https://api-boss-us-east-1.dev.tce.tillster.com',
  issApi: 'https://api-tps.dev.tillster.com/in-store-service',
  issApiKey: 'beb618ba-a358-45fb-9507-a521ab2512a2',
  pgaasApi: 'https://admin-pgaas-us-east-1.dev.eagle.tillster.com',
  publicPgaasApi: 'https://api-pgaas-us-east-1.dev.eagle.tillster.com',
  websocketApi: 'wss://ws-us-east-1.dev.tce.tillster.com/tce-realtime-notification',
  name: 'development',
  production: false,
  canDeleteItem: [
    'cbuckley@tillster.com',
    'jjoyave@tillster.com',
    'nbattula@tillster.com',
    'ncameron@tillster.com',
    'twerd@tillster.com',
    'lnammalvar@tillster.com',
    'rpantoja@tillster.com',
  ],
  recaptchaSiteKey: '6Lc21ewnAAAAAIrbcb98bUs7YyQBfyn5t8RaqG3N',
  txpAdminUrl: 'https://admin-txp-us-east-1.stage.tce.tillster.com',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
